import { useState, useEffect } from 'react'
import { api } from '@/lib/api'
import { Activity } from 'lucide-react'

interface ActivityLog {
  id: number
  user_name: string
  action: string
  resource_type: string | null
  resource_id: string | null
  timestamp: string
  ip_address: string | null
  details: any
}

export function ActivityLogs() {
  const [logs, setLogs] = useState<ActivityLog[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadLogs()
  }, [])

  const loadLogs = async () => {
    try {
      setLoading(true)
      const response = await api.getActivityLogs()
      setLogs(response.logs)
    } catch (error) {
      console.error('Load logs error:', error)
    } finally {
      setLoading(false)
    }
  }

  const formatAction = (action: string) => {
    return action.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  if (loading) {
    return <div className="text-slate-400">Loading activity logs...</div>
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Activity className="w-5 h-5 text-orange-400" />
        <h3 className="text-lg font-semibold">Recent Activity</h3>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-lg overflow-hidden">
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full">
            <thead className="bg-slate-900/50 border-b border-slate-700 sticky top-0">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-slate-400">Time</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-slate-400">User</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-slate-400">Action</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-slate-400">Resource</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700">
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-slate-800/30">
                  <td className="px-4 py-2 text-sm text-slate-400">
                    {new Date(log.timestamp).toLocaleString()}
                  </td>
                  <td className="px-4 py-2 text-sm">{log.user_name}</td>
                  <td className="px-4 py-2 text-sm">
                    <span className="px-2 py-1 rounded text-xs bg-blue-500/20 text-blue-400">
                      {formatAction(log.action)}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-sm text-slate-400">
                    {log.resource_type && (
                      <span>
                        {log.resource_type}
                        {log.resource_id && ` #${log.resource_id}`}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
